import type React from 'react';

import type { HandlerId } from '@vlabs/api/luna-api/model/HandlerId';
import { Link } from '@vlabs/uikit/components/controls/link/Link';
import { generatePath } from 'react-router-dom';

import { useHandlerQuery } from '@vlabs/monokit/entities/events/api';

import { useEventDetailsGeneralInfoTranslation } from '../i18n';
import st from './shared.module.sass';

interface HandlerRowProps {
  id: HandlerId;
  linkEnabled?: boolean;
}

function HandlerRow({ id, linkEnabled = true }: HandlerRowProps): React.JSX.Element {
  const { t } = useEventDetailsGeneralInfoTranslation();
  const { data: handler } = useHandlerQuery(id);

  if (!handler) return <span className={st.Null}>{t('deleted')}</span>;

  if (!linkEnabled) return <span className={st.Link}>{handler.description}</span>;

  return (
    <Link
      className={st.Link}
      size="large"
      to={generatePath('/handlers/:handlerId', { handlerId: id })}
    >
      {handler.description}
    </Link>
  );
}

export { HandlerRow };
